<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Create Purchase Request</h5>
    <form [formGroup]="AddNewProduct">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"><button type="button" (click)="openModal_Product(templateProduct)"
              class="btn btn-danger left"> Select Product <i class="fa fa-sticky-note"></i> </button> </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_Product_Record.title}}" />
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Count</label>
          <input formControlName="Amount" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Amount().valid && get_Form_Amount().touched"
            class="form-text text-muted MyErrorRedColor">Enter the quantity.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Estimated Price</label>
          <input formControlName="Price" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Price().valid && get_Form_Price().touched"
            class="form-text text-muted MyErrorRedColor">Enter the estimated price.</small>
        </div>
        <button type="button" class="btn btn-success" (click)="OnAdd_ProductRequestDetail()" ><i class="fa  fa-plus-circle"></i> Add Product </button>
      </div>

      <br />

      <div class="table-responsive" *ngIf="DataList_ProductRequestDetail.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Product Name</th>
              <th>Count</th>
              <th>Estimated Price (IRR)</th>
              <th>Total (IRR)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ProductRequestDetail">
             <td>{{DataList_ProductRequestDetail.indexOf(item)+1}}</td>

              <td>{{item.title}}</td>
              <td>{{item.amount}}</td>
              <td>{{item.price|number}}</td>
              <td>{{(item.price*item.amount)|number}}</td>
              <td>
                <button type="button" class="btn btn-danger" (click)="Delete_ProductRequestDetail(DataList_ProductRequestDetail.indexOf(item))" > Delete Product </button>
              </td>
            </tr>
            <tr>
              <td colspan="2">Grand Total (IRR)</td>
              <td colspan="4">{{Total_Price_Detail|number}}</td>
            </tr>
          </tbody>
        </table>
     </div>

      <br />
      <hr />
      <br />

      <div class="row">

        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Description</label>
          <input formControlName="Dsc" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched"
            class="form-text text-muted MyErrorRedColor">Enter the description.</small>
        </div>

      </div>



    </form>

    <br />
    <hr />
    <br />

    <h5 class="card-title">Requested Specifications</h5>

    <div class="row">

      <div class="input-group mb-12" *ngFor="let item of Datalist_Dsc" style="margin: 5px;">
        <div class="input-group-prepend" (click)="Remove_Dsc(Datalist_Dsc.indexOf(item))">
          <div class="input-group-text">
            <i class="fa fa-remove" style="color: red;"></i>
          </div>
        </div>
        <input type="text" [(ngModel)]="item.title" name="" class="form-control" id="inlineFormInputGroup"
          placeholder="Enter the requested specifications...">
      </div>


      <div class="input-group mb-12" style="margin: 5px;">
        <button (click)="Add_Dsc()" type="button" class="btn btn-info" style="margin-right: 5px;"><i
            class="fa  fa-plus-circle"></i> Add New Row </button>
      </div>


    </div>

    <br />
    <hr />
    <br />

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button (click)="SubmitAddNewProduct()" *ngIf="!InProccessing" type="button" [disabled]="!AddNewProduct.valid"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
    <button routerLink="/ProductRequest" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> Back </button>

  </div>
</div>


<ng-template #templateProduct>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Product List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Product.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Keyword </label>
          <input type="text" class="form-control" (keyup)="ReadData_Product_KeySearch()"
            [(ngModel)]="Search_Name_Product_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Product Name</th>
              <th>Product Group</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Product
            | paginate
                    : {
                        id: 'DataList_Product',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Product).length
                      }">
              <td>{{DataList_Product.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.group_title}}</td>
              <td (click)="Set_Selected_Product_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingProduct" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingProduct" type="button" (click)="ReadData_Product()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Product.hide()">Close</button>
  </div>
</ng-template>